import { render, staticRenderFns } from "./NotaFiscalDaGridDePedidos.vue?vue&type=template&id=2d52dc31&scoped=true&"
import script from "./NotaFiscalDaGridDePedidos.vue?vue&type=script&lang=js&"
export * from "./NotaFiscalDaGridDePedidos.vue?vue&type=script&lang=js&"
import style0 from "./NotaFiscalDaGridDePedidos.vue?vue&type=style&index=0&id=2d52dc31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52dc31",
  null
  
)

export default component.exports